import { render, staticRenderFns } from "./OrganisationSearchInput.vue?vue&type=template&id=0f67bc4a&scoped=true"
import script from "./OrganisationSearchInput.vue?vue&type=script&lang=ts"
export * from "./OrganisationSearchInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f67bc4a",
  null
  
)

export default component.exports